import _ from 'lodash'

import DimensionMuncher from './dimensionMuncher'
import Dimensions from './dimensions'
import PointDimensions from './pointDimensions'

export default class Lines extends DimensionMuncher {
  /**
   * memorizedObject - This method returns an object that all the values are set to zero
   * in order not to draw a line thar begins from an unexcepted coordinate.
   *
   * @method
   */
  memoizedObject(): object {
    const { xAxis } = this.axisNames()

    const values = _.uniq(this.data.map((item) => item[xAxis] !== undefined && item[xAxis]))

    return values.reduce((memo, item) => {
      memo[item] = 0

      return memo
    }, {})
  }

  /**
   * call - This method returns the data structure to print a line chart.
   *
   * @method
   */
  call() {
    return new Dimensions(this.data, this.axisNames(), this.dimensionGenerator()).call()
  }

  /**
   * dimensionGenerator - This method returns a PointDimensions object that have a DimensionsGenerator
   * that was prevously configured in order to generate a data structure to print lines chart
   * or area charts.
   *
   * @method
   */
  dimensionGenerator() {
    return new PointDimensions(this.query.id, this.axisNames(), this.memoizedObject()).call()
  }
}
